import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPracticeMetrics } from 'src/app/models/dashboard/metric.model';
import { IMco, IResultMcoModel } from 'src/app/models/dashboard/mco.model';
import {IResultKpiModel, IResultQualityScoreCard} from "../../../models/dashboard/kpi.model";
import {IResultProvider} from "../../../models/accounts/provider.model";
import {IResultPatient, SortOption} from "../../../models/dashboard/patient.model";
import {
  IPracticeMcoProductResult,
  PracticeMcoProductResult
} from "../../../models/dashboard/practice-mco-product.model";


@Injectable({
  providedIn: 'root'
})
export class DashboardHttpService {

  private readonly FIND_DASHBOARD_PRACTICE_URL = `${environment.apiUrl}/accounts/dashboard_practices/`;
  private readonly FIND_DASHBOARD_PRACTICE_MCO_URL = `${environment.apiUrl}/accounts/dashboard_practice_mco/`;

  constructor(private http: HttpClient) {
  }

  getKpi(practiceId: string): Observable<IResultKpiModel> {
    return this.http.get<IResultKpiModel>(`${environment.apiUrl}/catalog/kpi/?/&user_id=null&practice_id=${practiceId}`);

  }

  getQualityFilters(practiceId: string, type: string): Observable<any> {
    const url = `${environment.apiUrl}/catalog/app_quality_filters/?practice_id=${practiceId}&type=${type}`;
    return this.http.get<any>(url);
  }

  getQualityScore(
    wheres: Record<string, string>,
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultQualityScoreCard> {

    const params = Object.entries(wheres).reduce((acc, [key, value]) => {
      return value == null ? acc : acc.append(key, value);
    }, new HttpParams())
      .set('limit', String(limit))
      .set('offset', String(offset));

    return this.http.get<IResultQualityScoreCard>(
      `${environment.apiUrl}/catalog/app_quality_score/`,
      {params}
    );
  }


  dashboardPractice(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IPracticeMetrics> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IPracticeMetrics>(this.FIND_DASHBOARD_PRACTICE_URL, {params: pars});
  }

  dashboardPracticeMCO(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultMcoModel> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IResultMcoModel>(this.FIND_DASHBOARD_PRACTICE_MCO_URL, {params: pars});
  }

  dashboardfilterMCO(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultMcoModel> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IResultMcoModel>(`${environment.apiUrl}/accounts/mco/`, {params: pars});
  }

  dashboardMcoList(
    wheres: Record<string, string>,
    limit: number = 100,
    offset: number = 0
  ): Observable<IMco[]> {

    let params = new HttpParams()
      .set('limit', String(limit))
      .set('offset', String(offset));

    Object.entries(wheres ?? {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http.get<IMco[]>(`${environment.apiUrl}/accounts/mco_list/`, {params});
  }




  dashboardfilterRoles(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultMcoModel> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IResultMcoModel>(`${environment.apiUrl}/accounts/mco/`, { params: pars });
  }
  dashboardfilterProvider(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultProvider> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IResultProvider>(`${environment.apiUrl}/accounts/provider_practice/`, { params: pars });
  }
  dashboardfilterAccountProvider(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultProvider> {
    const pars = Object.entries(wheres).reduce((params, [key, value]) => {
      return params.append(key, value);
    }, new HttpParams())
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);
    return this.http.get<IResultProvider>(`${environment.apiUrl}/accounts/provider/`, { params: pars });
  }
  dashboardPatient(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<IResultPatient> {
    let params = new HttpParams()
      .append('limit', `${limit}`)
      .append('offset', `${offset}`);

    // Adding where conditions to HttpParams
    Object.entries(wheres).forEach(([key, value]) => {
      params = params.append(key, value);
    });



    return this.http.get<IResultPatient>(`${environment.apiUrl}/catalog/patient/`, { params });
  }

  getPracticeMcoProduct(practiceId:string): Observable<IPracticeMcoProductResult> {
    return this.http.get<IPracticeMcoProductResult>(`${environment.apiUrl}/catalog/practice_mco_product/?practice_id=${practiceId}`,{});
  }

  getMeasures(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0
  ): Observable<any> {
    const params = Object.entries(wheres).reduce((acc, [key, value]) => {
      return value == null ? acc : acc.append(key, value);
    }, new HttpParams())
      .set('limit', String(limit))
      .set('offset', String(offset));

    return this.http.get<any>(
      `${environment.apiUrl}/catalog/gap/`,
      { params }
    );
  }
}
